<template>
  <a
    :href="`/images-photos/${picTitleToHyphen(pic.title)}-${pic.taskId}`"
    @[clickEvent].prevent="toDetailHook()"
  >
  <!-- @click.stop="toDetailHook" -->
    <!-- <NuxtLinkLocale :to="`/images-photos/á-${pic.taskId}`"> -->
    <figure>
      <img
        :loading="loadingMethod"
        decoding="async"
        fetchpriority="high"
        class="masonry-img"
        :style="{ 'aspect-ratio': pic?.aspectRatio }"
        :src="imageUrl"
        :alt="pic.title"
        v-if="!pic.mainSrc"
      />
      <img
        v-else
        :loading="loadingMethod"
        decoding="async"
        fetchpriority="high"
        class="masonry-img"
        :style="{ 'aspect-ratio': pic?.aspectRatio }"
        :src="pic.mainSrc"
        :alt="pic.title"
        sizes="(max-width: 400px) 400px, (max-width: 799px) (100vw - 26px), (min-width: 800px) 400px"
        :srcset="$newResponseSrcset(pic.mainSrc, pic.width)"
      />
      <figcaption :title="pic.title" @mouseleave="handleMouseLeave">
        <div class="footer">
          <!-- <el-row justify="end" @click.stop.prevent>
            <el-popover :placement="'left-end'" :trigger="'click'" :hide-after="0" :teleported="false"
              :ref="(el) => (popoverRef[index] = el)" :persistent="false" popper-class="download-btn">
              <template #default>
                <div class="text">
                  <div class="text-entrance" @click.prevent="handleUseEnhance(pic)">
                    <icon-enhance />
                    <span>{{ $t('home.enhance') }}</span>
                  </div>
                  <div class="text-entrance" @click.prevent="handleUseTxtToImg(pic)">
                    <icon-txt-to-img />
                    <span>{{ $t('home.reimagine') }}</span>
                  </div>
                </div>
              </template>
              <template #reference>
                <div class="fav-icon entrance"></div>
              </template>
            </el-popover>
          </el-row> -->
          <el-row :justify="pic.uid ? 'space-between' : 'end'">
            <NuxtLinkLocale
              v-if="pic.uid"
              :to="`/images-photos/publisher/${pic.uid}`"
            >
              <el-space>
                <picture>
                  <source :srcset="avatarPreviewUrl" type="image/webp" />
                  <img
                    loading="lazy"
                    decoding="async"
                    width="32px"
                    height="32px"
                    style="border-radius: 50%; object-fit: cover"
                    :src="avatarUrl"
                  />
                </picture>
                {{ pic.userInfoVO?.nickName || userInfoVO.nickName || "" }}
              </el-space>
            </NuxtLinkLocale>

            <div class="footer-header-right">
              <div @click.stop.prevent>
                <icon-favorite
                  v-if="!favoriteFlag"
                  class="fav-icon"
                  @click.prevent="handlePicCollect"
                />
                <icon-favorite-collect
                  v-if="favoriteFlag"
                  class="fav-icon"
                  @click.prevent="handlePicCollect"
                />
              </div>
              <div @click.stop.prevent>
                <el-popover
                  :placement="'bottom'"
                  :trigger="'click'"
                  :hide-after="0"
                  :teleported="false"
                  :ref="(el) => (popoverRef[index] = el)"
                  :persistent="false"
                  popper-class="download-btn"
                >
                  <template #default>
                    <div class="text">
                      <div
                        class="text-entrance"
                        @click.prevent="handleUseEnhance(pic)"
                      >
                        <icon-enhance />
                        <span>{{ $t("home.enhance") }}</span>
                      </div>
                      <div
                        class="text-entrance"
                        @click.prevent="handleUseTxtToImg(pic)"
                      >
                        <icon-txt-to-img />
                        <span>{{ $t("home.reimagine") }}</span>
                      </div>
                    </div>
                  </template>
                  <template #reference>
                    <div class="fav-icon entrance"></div>
                  </template>
                </el-popover>
              </div>
            </div>
          </el-row>
        </div>
        <div class="header">
          <h3>{{ pic.title }}</h3>
        </div>
      </figcaption>
    </figure>
  </a>
</template>

<script setup>
import { goRouterPage, RouterPageConst } from "@/utils/routes_mapping.js";
const { $signUpDialog } = useNuxtApp();
const route = useRoute();
const { t, locale } = useI18n();
const localePath = useLocalePath();
const { pic, userInfoVO, index } = defineProps({
  pic: {
    required: true,
    default: {},
  },
  index: {
    type: Number,
    default: 0,
  },
  userInfoVO: {
    default: {},
  },
  loadingMethod: {
    default: "auto",
  },
});

const avatarUrl = computed(() => {
  return pic.userInfoVO?.avatarUrl || userInfoVO.avatarUrl || "";
});

const avatarPreviewUrl = computed(() => {
  return pic.userInfoVO?.previewResultUrl || avatarUrl.value;
});


const imageUrl = computed(() => {
  return pic.imageUrl || pic.url;
});
const previewImageUrl = computed(() => {
  return pic.previewResultUrl || imageUrl.value;
});

const currentUserId = route.params?.id;

const favoriteFlag = ref(pic.collect);
const handlePicCollect = async (e) => {
  sessionStorage.removeItem('isClicked'); // 移除点击
  if (!isLogined()) {
    $signUpDialog();
    return;
  }

  try {
    const api = favoriteFlag.value ? useUncollectPic : useCollectPic;
    favoriteFlag.value = !favoriteFlag.value;
    await api({
      taskId: pic.taskId,
    });
  } catch (error) {
    favoriteFlag.value = !favoriteFlag.value;
  }
};

const handleUseEnhance = (pic) => {
  if (!isLogined()) {
    $signUpDialog();
    return;
  }
  localStorage.setItem("imageUrlToEnhance", imageUrl.value);
  goRouterPage(RouterPageConst.EnhanceImage, locale.value, true);
};

const handleUseTxtToImg = (pic) => {
  localStorage.setItem(
    "txttoimgparams",
    JSON.stringify({
      ...pic,
      promptKeyword: pic.prompt || pic.originalPrompt,
      promptImageSize: pic.ratio,
      promptImageStyleKey: pic.model,
    }),
  );
  goRouterPage(RouterPageConst.TxtToImg, locale.value, true);
};

const popoverRef = ref([]);

const handleMouseLeave = () => {
  popoverRef.value[index]?.hide();
};

const handleScroll = () => {
  popoverRef.value[index]?.hide();
};

// 点击跳转
const handleClick = () => {
  navigateTo(`/images-photos/${picTitleToHyphen(pic.title)}-${pic.taskId}`);
};

const isMobile =() => {
	 let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
	 return flag;
}


const toDetailHook = () => {
  if (import.meta.client) {
    localStorage.setItem(
      "discoverImgRatio",
      getRatioValueWithString(pic.ratio),
    );
  }
  if (!isMobile()) {
    handleClick();
    return;
  }
  if (sessionStorage.getItem('isClicked') === pic.taskId) {
    handleClick();
  } else {
    sessionStorage.setItem('isClicked', pic.taskId);
  }
};

const clickEvent = ref(null);
onMounted(() => {
  const navigator = window.navigator;
  const userAgent = navigator.userAgent;
  const normalizedUserAgent = userAgent.toLowerCase();
  const isIos =
    /ip(ad|hone|od)/.test(normalizedUserAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
  clickEvent.value = isIos ? null : 'click';
  // clickEvent.value = 'click';
  window.addEventListener('scroll', handleScroll); // 监听滚动事件
});
onBeforeUnmount(() => {
  sessionStorage.removeItem('isClicked'); // 移除点击
  window.removeEventListener('scroll', handleScroll); // 移除事件监听器
});
</script>

<style scoped lang="scss">
figure {
  display: block;
  margin: 0;
  position: relative;
  overflow: hidden;
  // border: 2px solid #ccc;
  // border-radius: 0.5em;
  cursor: zoom-in;

  .masonry-img {
    display: block;
    object-fit: cover;
    width: 100%;
    color: transparent;
    // min-height: 200px;
    background-color: #e8eaf0;
  }
}

figcaption {
  display: flex;
  opacity: 0;
  transition: opacity 300ms ease-in-out;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  color: #fff;
  // background-image: linear-gradient(180deg, rgba(0, 0, 0, .34) 0, rgba(0, 0, 0, .338) 3.5%, rgba(0, 0, 0, .324) 7%, rgba(0, 0, 0, .306) 10.35%, rgba(0, 0, 0, .285) 13.85%, rgba(0, 0, 0, .262) 17.35%, rgba(0, 0, 0, .237) 20.85%, rgba(0, 0, 0, .213) 24.35%, rgba(0, 0, 0, .188) 27.85%, rgba(0, 0, 0, .165) 31.35%, rgba(0, 0, 0, .144) 34.85%, rgba(0, 0, 0, .126) 38.35%, rgba(0, 0, 0, .112) 41.85%, rgba(0, 0, 0, .103) 45.35%, rgba(0, 0, 0, .1) 48.85%, rgba(0, 0, 0, .103) 52.35%, rgba(0, 0, 0, .112) 55.85%, rgba(0, 0, 0, .126) 59.35%, rgba(0, 0, 0, .144) 62.85%, rgba(0, 0, 0, .165) 66.35%, rgba(0, 0, 0, .188) 69.85%, rgba(0, 0, 0, .213) 73.35%, rgba(0, 0, 0, .237) 76.85%, rgba(0, 0, 0, .262) 80.35%, rgba(0, 0, 0, .285) 83.85%, rgba(0, 0, 0, .306) 87.35%, rgba(0, 0, 0, .324) 90.85%, rgba(0, 0, 0, .338) 94.35%, rgba(0, 0, 0, .347) 97.85%, rgba(0, 0, 0, .35));
  background-image: linear-gradient(
    0deg,
    rgba(0, 0, 0, 0.38) 0,
    rgba(0, 0, 0, 0.2) 40%,
    rgba(0, 0, 0, 0.14) 60%,
    rgba(0, 0, 0, 0.1) 80%
  );

  figure:hover & {
    opacity: 1;
  }
  .header {
    background: linear-gradient( 180deg,rgba(29,29,32,0) 0%, rgba(29,29,32,0.3) 100%);
    position: absolute;
    padding: 0 15px 15px 15px;
    bottom: 0px;
    font-weight: 400;
    font-size: 16px;
    color: #ffffff;
    line-height: 19px;
    text-align: left;
    max-height: 80px; /* 根据行高调整 */
    display: flex;
    height: 80px;
    flex-direction: column;
    justify-content: end;
    width: 100%;
    h3 {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2; /* 控制显示的行数 */
      overflow: hidden;
      text-overflow: ellipsis;
      width: 100%;
      max-height: 38px; /* 根据行高调整 */
    }
  }
  .footer {
    position: absolute;
    padding: 15px 15px 0px 15px;
    top: 0px;
    min-height: 100px;
    display: flex;
    flex-direction: column;
    gap: 15px;
    height: 80px;
    width: 100%;
background: linear-gradient( 180deg, rgba(29,29,32,0.3) 0%, rgba(29,29,32,0) 100%);
    // background: linear-gradient(0deg,  rgba(0, 0, 0, 0.3) 0%, rgba(29,29,32,0) 100%);
    .footer-header-right {
      display: flex;
      gap: 15px;
    }

    :deep().el-row {
      height: 32px;
    }

    .fav-icon {
      width: 36px;
      height: 32px;
      padding: 8px 11px;
      color: #000;
      background-color: #fff;
      border-radius: 4px;
      cursor: pointer;

      &.entrance {
        padding: 8px 9px;
        background: url("~/assets/images/webp/entrance@2x.webp") #fff no-repeat
          center center;
        background-size: 18px;
      }

      &.collect {
        padding: 0;
      }

      .is-favorite {
        color: $theme-clo;
      }
    }
  }
}

@media (any-hover: hover) {
  figcaption .footer .fav-icon.entrance:hover {
    background: url("~/assets/images/webp/entrance-hover@2x.webp") #fff
      no-repeat center center;
    background-size: 18px;
  }

  .download-btn .text .text-entrance:hover {
    background: #f4f5f6;
  }
}

// figcaption {
//   background-image: none;

//   figure & {
//     opacity: 1;
//   }
// }

@media (max-width: 799px) {
  figcaption {
    background-image: none;

    figure & {
      // opacity: 1;
    }
  }
}

:deep().el-popover.el-popper {
  padding: 5px;

  border-radius: 6px 6px 6px 6px;
  min-width: fit-content !important;

  cursor: pointer;

  &.download-btn {
    width: fit-content !important;
    z-index: 10 !important;

    .text {
      display: flex;
      flex-direction: column;
      gap: 5px;

      .text-entrance {
        display: inline-flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        height: 28px;
        padding: 0 5px;
        box-sizing: border-box;
        font-weight: 400;
        font-size: 14px;
        color: #303131;
        line-height: 16px;
        border-radius: 4px 4px 4px 4px;
        overflow: hidden;

        svg {
          width: 20px;
          height: 20px;
        }
      }
    }
  }
}
</style>
